import * as types from '../actions/types';

const initialState = {
    wait: false,
    data: [],
    selected: null,
    error: null,
};

export default function (state=initialState, {type, payload}) {
    switch (type) {

        // list
        case types.GET_ALL_BUYERMAP_WAIT:
            return {
                ...state,
                wait: true,
                error: null,
            };
        case types.GET_ALL_BUYERMAP_SUCCESS:
            return {
                ...state,
                wait: false,
                data: [...payload],
            };
        case types.GET_ALL_BUYERMAP_ERROR:
            return {
                ...state,
                wait: false,
                data: [],
                error: payload,
            };

        default:
            return state;
    }
}
